import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const PROPERTY_OWNERSHIP_STATUS = {
  OWNER: 'owner',
  CO_OWNER: 'co_owner',
  TENANT: 'tenant',
} as const;

export const PROPERTY_OWNERSHIP_STATUS_NAME = 'property_ownership_status';

interface Props {
  name?: string;
}

export const RadioGroupPropertyOwnershipStatus: FC<Props> = ({
  name = PROPERTY_OWNERSHIP_STATUS_NAME,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {i18n.t('Jaki jest Twój status własności nieruchomości?')}
          </FormLabel>
          <FormControl>
            <RadioGroup {...field} layout={'vertical'}>
              <RadioItem
                data-testid={`${name}-radio-group-${PROPERTY_OWNERSHIP_STATUS.OWNER}`}
                value={PROPERTY_OWNERSHIP_STATUS.OWNER}
                label={i18n.t('Właściciel')}
              />
              <RadioItem
                data-testid={`${name}-radio-group-${PROPERTY_OWNERSHIP_STATUS.CO_OWNER}`}
                value={PROPERTY_OWNERSHIP_STATUS.CO_OWNER}
                label={i18n.t('Współwłaściciel')}
              />{' '}
              <RadioItem
                data-testid={`${name}-radio-group-${PROPERTY_OWNERSHIP_STATUS.TENANT}`}
                value={PROPERTY_OWNERSHIP_STATUS.TENANT}
                label={i18n.t('Najemca')}
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
